/**
 * @file oidcConfig.js
 * @brief Defines the frontend OpenID Connect client settings used by react-oidc-context.
 */
// src/oidcConfig.js
export const oidcConfig = {
    authority: process.env.REACT_APP_OIDC_AUTHORITY,
    client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI,
    post_logout_redirect_uri: process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI,
    scope: "openid profile email",
    automaticSilentRenew: true,

    silent_redirect_uri: window.location.origin + "/silent-renew.html", 
    
    // Notify the user 60 seconds before the access token expires
    accessTokenExpiringNotificationTimeInSeconds: 60,
    
    // ── Clean the URL after Keycloak redirects back ───────────────────────
    // Without this, the ?state=...&code=...&session_state=... parameters
    // stay in the URL forever, breaking F5 refresh (Keycloak rejects a
    // replayed code) and making the URL ugly.
    //
    // react-oidc-context calls this after it has finished processing the
    // callback parameters, so it's safe to wipe the query string here.
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    },
};